angular.module('MyHippoProducer.Controllers').directive('coveragesSection', function () {
    return {
        restrict: 'E',
        scope: {},
        templateUrl: 'pages/policy-details/sections/coverages/coverages.html',
    };
});
